import { Reducer } from 'react';
import { ICountryCode } from '../../interfaces';

export enum NewsletterStepsEnum {
    Initial = 'initial',
    EmailSubscription = 'email-subscription',
    Success = 'success',
}

type State = {
    step: NewsletterStepsEnum;
    isLoading: boolean;
    obcCredit: Partial<Record<ICountryCode, number>>;
};

type Action =
    | { type: 'SET_STEP'; payload: NewsletterStepsEnum }
    | { type: 'SET_LOADING'; payload: boolean };

export const initialState: State = {
    step: NewsletterStepsEnum.Initial,
    isLoading: false,
    obcCredit: {
        de: 30,
        nl: 30,
        c1uk: 50,
    },
};

export const newsletterReducer: Reducer<State, Action> = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_STEP':
            return {
                ...state,
                step: action.payload,
            };
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: action.payload,
            };
        default:
            return state;
    }
};
